import { render } from "./AdminMain.vue?vue&type=template&id=c5901a1e&scoped=true&ts=true"
import script from "./AdminMain.vue?vue&type=script&lang=ts"
export * from "./AdminMain.vue?vue&type=script&lang=ts"

import "./AdminMain.vue?vue&type=style&index=0&id=c5901a1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5901a1e"]])

export default __exports__